import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CustomerList from './CustomerList';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Table,
  Button,
  Form,
  Row,
  Col
} from 'react-bootstrap';

const CustomerManagement = () => {
  const [customers, setCustomers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const API_BASE = process.env.REACT_APP_API_BASE_URL;


   
   // Get authentication token from localStorage or wherever you store it
   const token = localStorage.getItem('admin_token');
   console.log(token)
   const headers = {
     'Authorization': `Bearer ${token}`
   };
  useEffect(() => {
    axios.get(`${API_BASE}/api/customers_a`,{headers})
      .then(res => {
        setCustomers(res.data);
        setFilteredCustomers(res.data);
      })
      .catch(err => console.error('Error fetching customers:', err));
  }, []);

  useEffect(() => {
    const term = searchTerm.toLowerCase();
    const filtered = customers.filter(c =>
      c.customer_id.toString().includes(term) ||
      c.company_name.toLowerCase().includes(term)
    );
    setFilteredCustomers(filtered);
    setCurrentPage(1);
  }, [searchTerm, customers]);

  const handleAdd = () => navigate('/admin/customers/add');
  const handleEdit = (id) => navigate(`/admin/customers/edit/${id}`);
  const handleView = (id) => navigate(`/admin/customers/view/${id}`);

  const handleDelete = (id) => {
    if (!window.confirm("Are you sure you want to delete this customer?")) return;
    axios.delete(`${API_BASE}/api/customers_a/delete/${id}`,{headers})
      .then(() => {
        const updated = customers.filter(c => c.customer_id !== id);
        setCustomers(updated);
      })
      .catch(err => console.error('Error deleting customer:', err));
  };

  const handleRowsChange = (e) => {
    const value = e.target.value;
    setRowsPerPage(value === 'all' ? filteredCustomers.length : parseInt(value));
    setCurrentPage(1);
  };

  const indexOfLast = currentPage * rowsPerPage;
  const indexOfFirst = indexOfLast - rowsPerPage;
  const currentCustomers = filteredCustomers.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredCustomers.length / rowsPerPage);

  return (
    <Container className="mt-4">
      <h2 className="mb-4">Customer Management</h2>

      <Row className="mb-3">
        <Col md={6}>
          <Form.Control
            type="text"
            placeholder="Search customers..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </Col>
        <Col md={3}>
          <Form.Select
            value={rowsPerPage === filteredCustomers.length ? "all" : rowsPerPage}
            onChange={handleRowsChange}
          >
            <option value="10">Show 10</option>
            <option value="20">Show 20</option>
            <option value="all">Show All</option>
          </Form.Select>
        </Col>
        <Col md={3} className="text-end">
          <Button variant="primary" onClick={handleAdd}>
            Add Customer
          </Button>
        </Col>
      </Row>

      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>#</th>
            <th>Customer ID</th>
            <th>Company Name</th>
            
            <th>Email</th>
            <th>Phone</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentCustomers.map((customer, index) => (
            <tr key={customer.customer_id}>
              <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
              <td>{customer.customer_id}</td>
              <td>{customer.company_name}</td>
              
              <td>{customer.email}</td>
              <td>{customer.phone}</td>
              <td>
                <Button
                  variant="info"
                  size="sm"
                  className="me-1"
                  onClick={() => handleView(customer.customer_id)}
                >
                  View
                </Button>
                <Button
                  variant="warning"
                  size="sm"
                  className="me-1"
                  onClick={() => handleEdit(customer.customer_id)}
                >
                  Edit
                </Button>
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => handleDelete(customer.customer_id)}
                >
                  Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {rowsPerPage !== filteredCustomers.length && totalPages > 1 && (
        <div className="d-flex justify-content-center mt-4">
          {Array.from({ length: totalPages }, (_, i) => (
            <Button
              key={i}
              variant={currentPage === i + 1 ? "primary" : "outline-primary"}
              size="sm"
              className="me-1"
              onClick={() => setCurrentPage(i + 1)}
            >
              {i + 1}
            </Button>
          ))}
        </div>
      )}
    </Container>
  );
};

export default CustomerManagement;